/**
 * AboutENAboutPageView
 *
 * Page component for AboutENAboutPageView
 * Path: /about
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AboutENAboutPageView as __AboutENAboutPageView } from '@/components/traits/AboutENAboutPageView';
import { AboutENAboutAnalyticsView as __AboutENAboutAnalyticsView } from '@/components/traits/AboutENAboutAnalyticsView';
import { AboutENDemoChecksFetcherView as __AboutENDemoChecksFetcherView } from '@/components/traits/AboutENDemoChecksFetcherView';
import { AboutENDemoChecksDeskView as __AboutENDemoChecksDeskView } from '@/components/traits/AboutENDemoChecksDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface AboutENAboutPageViewProps {
  // Add any page-level props here
}

export function AboutENAboutPageView(_props: AboutENAboutPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-about:meta.title"],"description":["i18n/t","std-almadar-about:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/about"},{"locale":"ar","path":"/ar/about"},{"locale":"sl","path":"/sl/about"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AboutENAboutPageView config={{ initPayload: __navState }} />
          <__AboutENAboutAnalyticsView config={{ initPayload: __navState }} />
          <__AboutENDemoChecksFetcherView config={{ initPayload: __navState }} />
          <__AboutENDemoChecksDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default AboutENAboutPageView;
